import { isAxiosError } from 'axios'
import { store } from '../../app/store'
import APIClient from '../../apiClient'
import StatusE from '../../types/statusE'
import { setStatus, setError, setResponse, setIncidentDetail } from './slice'
import { IncidentT } from '../../types/incidentT'
import { IncidentResponseT } from '../../types/incidentResponseT'
import { ErrorTypeE } from '../../types/errorT'
import { PeopleT } from '../../types/peopleT'
import { ImageT } from '../../types/imageT'

const apiClient = new APIClient()
const apiInstance = apiClient.getInstance()

export const createIncident = (incident: IncidentT) => (dispatch: typeof store.dispatch) => {
  dispatch(setStatus(StatusE.LOADING))

  const resultPayload = {
    ...incident,
    people: incident.people.map((person: PeopleT) => {
      const { phoneNumberSuffix, ...restPerson } = person // eslint-disable-line @typescript-eslint/naming-convention
      return {
        ...restPerson,
        phone_number: `${phoneNumberSuffix}${person.phone_number?.replaceAll('-', '')}`,
        images: (person.images as ImageT[] | undefined)?.map((img) => ({ type: img.type, uri: img.uri })),
      }
    }),
  }

  apiInstance
    .post<IncidentResponseT>(`/incident`, resultPayload, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      dispatch(setResponse(response.data))
    })
    .catch((error) => {
      if (isAxiosError(error)) {
        dispatch(setError(error.response?.data))
        return
      }
      dispatch(setError({ status: ErrorTypeE.INTERNAL_ERROR }))
    })
}

export const getIncidentDetail = (incidentId: string) => (dispatch: typeof store.dispatch) => {
  dispatch(setStatus(StatusE.LOADING))
  apiInstance
    .get<IncidentResponseT>(`/incident/${incidentId}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      dispatch(setIncidentDetail(response.data.data))
    })
    .catch((error) => {
      if (isAxiosError(error) && error.response?.status === 404) {
        dispatch(setError({ status: '404', message: 'Incident not found' }))
      } else if (isAxiosError(error)) {
        dispatch(setError(error.response?.data))
      } else {
        dispatch(setError({ status: ErrorTypeE.INTERNAL_ERROR }))
      }
    })
}
